<template>
	<v-container fluid>
      <div class="text-center text-h3">
        Reporte de Incidencias del Mes
      </div>
		<!-- <v-row class="text-center">
			<v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-autocomplete
					v-model="filtros.idArea"
					:items="areas"
					item-value="idArea"
					item-text="nombre"
					label="Área"
					hide-details
					:disabled="nombreEmpresa === 'Nyx' || nombreEmpresa === 'Glm'"
					@change="getSeries()"
				></v-autocomplete>
			</v-col>
			<v-col v-if="nombreEmpresa === 'Nyx' || nombreEmpresa === 'Glm'" cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-autocomplete
					v-model="idTurno"
					:items="turnos"
					item-text="nombre"
					item-value="idTurno"
					label="Turno"
					hide-details
					:disabled="nombreEmpresa === 'Nyx' || nombreEmpresa === 'Glm'"
				></v-autocomplete>
			</v-col>
			<v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-select
					v-model="filtros.idOEEFactor"
					:items="oeeFactores"
					item-value="idOEEFactor"
					item-text="nombre"
					label="Factor OEE"
					hide-details
					clearable
					:disabled="nombreEmpresa === 'Nyx' || nombreEmpresa === 'Glm'"
					@change="getSeries()"
				></v-select>
			</v-col>
		</v-row> -->


		<div style="position: relative;">
			<div
				style="
				position: absolute;
				top: 8px;
				right: 120px; /* <- este valor ajusta la alineación exacta */
				font-weight: bold;
				font-size: 16px;
				z-index: 10;
				background: white;
				padding: 2px 6px;
				">
				SubCausas
			</div>

			<apexchart
				type="bar"
				height="350"
				:options="chartOptions"
				:series="series"
			></apexchart>
		</div>
	</v-container>
</template>

<script>
import axios from "axios";
import {mapState} from "vuex";
export default {
	data() {
		return {
			tiposParos: [
				{
					id: 1,
					value: "Sensor",
				},
				{
					id: 2,
					value: "Manual",
				},
			],
			instancias: [],
			personas: [],
			operadores: [],
			articulosFase: [],
			articulosProducir: [],
			claves: [],
			areas: [],
			tipoSubparos: [],
			tipoParos: [],
			oeeFactores: [],
			previewVisible: false,
    		previewUrl: null,
			turnos: [],
			idTurno: null,
			tipoIncidencias: [
				{
					id: true,
					text: "Paro",
				},
				{
					id: false,
					text: "Reporte",
				},
			],
			filtros: {
				idTipoParo: null,
				idOEEFactor: 3,
				idParoTipo: null,
				idSubParoTipo: null,
				clave: null,
				idArticuloProducir: null,
				idArticuloFase: null,
				idArea: null,
				idReporto: null,
				idResponsable: null,
				inicio: null,
				fin: null,
				bloqueoProduccion: false,
			},
			series: [],
			chartOptions: null,
			loading: false,
			dialogVisible: false,
			selectedData: {
				category: '',
				serie: '',
				valor: 0,
			},
			paros: [], 
    		paros_total: 0,
    		paros_actual_page: 1,
    		paros_items_per_page: 10,
			parosRelacionados: [], 
		};
	},
	created(){
		const rango = this.fechaPorDefecto();
		this.filtros.inicio = rango.inicio;
		this.filtros.fin = rango.fin;
		this.initialize();
	},
	computed: {
		...mapState({
			nombreEmpresa: "nombreEmpresa"
		}),
		subTipoParoFiltrados() {
			if (this.$utils.isValid(this.filtros.idParoTipo))
				return this.tipoSubparos.filter(
					(tp) => tp.idParoTipo == this.filtros.idParoTipo
				);
			else return this.tipoSubparos;
		},
		tipoParosFiltrados() {
			if (
				this.$utils.isValid(this.filtros.idOEEFactor) &&
				this.filtros.idOEEFactor >= 0
			) {
				const idOEEFactor =
					this.filtros.idOEEFactor == 0
						? null
						: this.filtros.idOEEFactor;
				return this.tipoParos.filter(
					(tp) => tp.idOEEFactor == idOEEFactor
				);
			} else {
				return this.tipoParos;
			}
		},
	},
	beforeMount() {
		this.setDefaultsChart();
	},
	watch: {
		nombreEmpresa(newVal) {
		  if (newVal === 'Nyx') {
		    this.filtros.idTipoParo = 2;
			this.filtros.idOEEFactor = 3;
			} else if (newVal === 'Glm') {
			this.filtros.idTipoParo = 4;
			this.filtros.idOEEFactor = 3;
		  }
		}
	},
		mounted() {
		if (this.nombreEmpresa === 'Nyx') {
			this.filtros.idTipoParo = 2;
			this.filtros.idOEEFactor = 3;
		} else if (this.nombreEmpresa === 'Glm') {
			this.filtros.idTipoParo = 4;
			this.filtros.idOEEFactor = 3;
		}
	},
	methods: {
		nombrePersona: (persona) =>
			persona.nombre + " " + persona.paterno + " " + persona.materno,
		initialize() {
			this.getSeries();
			this.getOEEFactores();
			this.getTipoParos();
			this.getTipoSubParos();
			this.getPersonas();
			this.getOperadores();
			this.getClaves();
			this.getArticulosProducir();
			this.getArticulosFase();
			this.getAreas();
			this.getAreasNyx();
			this.getTurnos();
			this.getInstancias();
		},
		getPersonas() {
			axios
				.get("/Personas")
				.then((response) => {
					this.personas = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getOperadores() {
			axios
				.get("/Personas/Operadores")
				.then((response) => {
					this.operadores = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getArticulosFase() {
			axios
				.get("/Articulos/ArticulosNombres?componentes=true")
				.then((response) => {
					this.articulosFase = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getArticulosProducir() {
			axios
				.get("/Articulos/OTS")
				.then((response) => {
					this.articulosProducir = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getClaves() {
			axios
				.get("/TrabajoOrdenes/TrabajoOrdenHeaders")
				.then((response) => {
					this.claves = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getAreas() {
			axios
				.get("/Areas")
				.then((response) => {
					this.areas = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getAreasNyx() {
			axios
				.get("/Areas")
				.then((response) => {
				this.areas = response.data;
				if (this.nombreEmpresa === 'Nyx') {
					const defaultId = 6;
					const areaEncontrada = this.areas.find(area => area.idArea === defaultId);
					if (areaEncontrada) {
					this.filtros.idArea = defaultId;
					}
				} else if (this.nombreEmpresa === 'Glm') {
					// Para Glm todas las áreas de momento
					this.filtros.idArea = null;
				}
				this.getSeries();
				})
				.catch((error) => {
				console.log(error);
				});
		},
		fechaPorDefecto() {
			const today = new Date();
			const firstDay = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0);

			const pad = n => n < 10 ? '0' + n : n;
			const format = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;

			return {
			inicio: `${firstDay.getFullYear()}-${pad(firstDay.getMonth() + 1)}-01 00:00`,
			fin: format(today)
			};
		},
		getTurnos() {
			axios
			.get("/Turnos")
			.then((response) => {
				this.turnos = response.data;
				//this.detectarTurnoActual();
				//console.log("los turnos son:", this.turnos);
			})
			.catch((error) => {
				console.log(error);
			});
		},
		// detectarTurnoActual() {
		// 	const ahora = new Date();
		// 	const minutosActuales = ahora.getHours() * 60 + ahora.getMinutes();

		// 	const convertirAHoras = (horaStr) => {
		// 		const [h, m] = horaStr.split(":").map(Number);
		// 		return h * 60 + m;
		// 	};

		// 	for (const turno of this.turnos) {
		// 		const inicio = convertirAHoras(turno.inicio);
		// 		const fin = convertirAHoras(turno.fin);

		// 		if (inicio < fin) {
		// 		// Turno normal
		// 		if (minutosActuales >= inicio && minutosActuales < fin) {
		// 			this.idTurno = turno.idTurno;
		// 			break;
		// 		}
		// 		} else {
		// 		// Turno que cruza medianoche
		// 		if (minutosActuales >= inicio || minutosActuales < fin) {
		// 			this.idTurno = turno.idTurno;
		// 			break;
		// 		}
		// 		}
		// 	}
		// },
		getTipoSubParos() {
			axios
				.get("/SubParoTipos")
				.then((response) => {
					this.tipoSubparos = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		changeParoTipo() {
			this.filtros.idSubParoTipo = null;
			this.getSeries();
		},
		getTipoParos() {
			axios
				.get("/ParoTipos")
				.then((response) => {
					this.tipoParos = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getInstancias(){
			axios
				.get("/MaquinaInstancias")
				.then( response => {
					this.instancias = response.data;
				})
				.catch( error => {
					console.log(error);
				})
		},
		getOEEFactores() {
			axios
				.get("/OEEFactores")
				.then((response) => {
					this.oeeFactores = response.data;
					//console.log("los factores son: ", this.oeeFactores);
					this.oeeFactores.push({
						idOEEFactor: 0,
						nombre: "SIN ESPECIFICAR",
						descripcion: "Sin Especificar",
					});
				})
				.catch((error) => {
					console.log(error);
				});
		},
		// getOEEFactoresNyx() {
		//   axios
		// 	.get("/OEEFactores")
		// 	.then((response) => {
		// 	this.oeeFactores = response.data;
		// 	const defaultId = 3;
		// 	const oeeEncontrado = this.oeeFactores.find(area => area.idArea === defaultId);
		// 	if (oeeEncontrado) {
		// 	  this.filtros.idOEE = defaultId;
		// 	  this.getSeries(); 
		// 	}
		// 	})
		// 	.catch((error) => {
		// 	console.log(error);
		// 	});
		// },
		getSeries() {
			this.loading = true;

			axios
				.get("/Paros/GraficaParos", {
					params: {
						paginar: false,
						idParoTipo: this.filtros.idParoTipo,
						idSubParoTipo: this.filtros.idSubParoTipo,
						idTrabajoOrden: this.filtros.clave,
						idArticuloProducir: this.filtros.idArticuloProducir,
						idArticuloFase: this.filtros.idArticuloFase,
						idArea: this.filtros.idArea,
						idReporto: this.filtros.idReporto,
						idResponsable: this.filtros.idResponsable,
						idOEEFactor: 3,
						bloqueoProduccion: this.filtros.bloqueoProduccion,
						inicio: this.filtros.inicio,
						fin: this.filtros.fin,
						tipoParo: this.filtros.idTipoParo,
						idMaquinaIns: this.filtros.instancias,
					},
				})
				.then(({ data }) => {
          // 1) Transformamos y ordenamos
          const ordenadas = data.series
            .map(s => ({ name: s.name, value: s.data[0] }))
            .sort((a, b) => b.value - a.value);

          // 2) Extraemos categorías y valores
          const categorias = ordenadas.map(o => o.name);
          const valores    = ordenadas.map(o => o.value);

          // 3) Reinicializamos el chart con las nuevas categorías
          this.setDefaultsChart(categorias);

          // 4) Una sola serie con todos los valores
          this.series = [{
            name: 'Incidencias',
            data: valores
          }];
        })
        .catch(error => {
          this.setDefaultsChart();
          this.series = [];
        })
        .finally(() => {
          this.loading = false;
        });
      },
		descargarPDF(idParo) {
			const url = `/Paros/ReportePDFImagenes?IdParo=${idParo}`;
			const fileName = `ReporteParo.pdf`;
			this.$utils.axios.downloadFile(
				url,
				"GET",
				fileName, // Nombre del archivo con ID y fecha
				"application/pdf" // Tipo MIME para PDF
			);
		},
		setDefaultsChart(categories = []) {
			this.chartOptions = {
				chart: {
					type: "bar",
					height: 350,
					stacked: false,
					events: {
						dataPointSelection: async (event, chartContext, config) => {
							const categoria = this.chartOptions.xaxis.categories[config.dataPointIndex];
							const serie = this.series[config.seriesIndex].name;
							const valor = this.series[config.seriesIndex].data[config.dataPointIndex];
							const idParoTipo = this.series[config.seriesIndex].metaData?.[config.dataPointIndex];

							this.selectedData = { category: categoria, serie, valor };

							// Abre el diálogo de inmediato
							this.dialogVisible = true;

							// Prepara loading y limpia datos
							this.loading = true;
							this.paros = [];
							this.paros_total = 0;

							try {
								const response = await axios.get("/Paros/GraficaParosFotos", {
								params: {
									paginar: false,
									idParoTipo: idParoTipo,
									idSubParoTipo: this.filtros.idSubParoTipo,
									idTrabajoOrden: this.filtros.clave,
									idArticuloProducir: this.filtros.idArticuloProducir,
									idArticuloFase: this.filtros.idArticuloFase,
									idArea: this.filtros.idArea,
									idReporto: this.filtros.idReporto,
									idResponsable: this.filtros.idResponsable,
									idOEEFactor: 3,
									bloqueoProduccion: this.filtros.bloqueoProduccion,
									inicio: this.filtros.inicio,
									fin: this.filtros.fin,
									tipoParo: this.filtros.idTipoParo,
									idMaquinaIns: this.filtros.instancias,
								},
								});

								this.paros = (response.data || []).map(p => ({
								...p,
								proceso: `Fase: ${p.articuloFase || 'N/D'}`,								
								reportadoPorOperadores: (p.reportadoPor?.length > 0)? p.reportadoPor: (p.operadoresReales?.length > 0 ? p.operadoresReales : ['Sin definir']),
								maquina: {
									marca: p.marca || 'N/D',
									modelo: p.modelo || 'N/D',
									codigo: p.codigo || 'N/D'
								}
								}));
								this.paros_total = this.paros.length;
  								this.paros_actual_page = 1;
							} catch (error) {
								console.error("Error al obtener paros relacionados:", error);
							} finally {
								this.loading = false;
							}
						}
					},
					toolbar: {
						show: true,
					},
					zoom: {
						enabled: true,
					},
				},
				responsive: [
					{
						breakpoint: 480,
						options: {
							legend: {
								position: "bottom",
								offsetX: -10,
								offsetY: 0,
							},
						},
					},
				],
				 plotOptions: {
          bar: {
            horizontal: false,
            distributed: true,     // un color por barra
            columnWidth: "60%",    // ancho relativo de cada barra
            dataLabels: {
              position: "center"       // muestra el valor encima de cada barra
            }
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "12px",
            fontWeight: 600,
            colors: ["#000"]
          }
       },
				xaxis: {
					type: "category",
					categories,
          labels: {
            show: true,
            style: {
              fontSize: "4px",  // tamaño legible
              fontWeight: 500
            }
          }
				},
				legend: {
					show: false
				},
				fill: {
					opacity: 1,
				},
        yaxis: {
          min: 0,
          tickAmount: 5,
          forceNiceScale: true  // ApexCharts buscará “nice” ticks
        }
			};
		},
		async verParoPreview(idParo) {
			const res = await axios.get(`/Paros/PreviewParoPdf/${idParo}`, {
				responseType: 'blob'
			});
			const blob = new Blob([res.data], { type: 'application/pdf' });
			const url = URL.createObjectURL(blob);

			// Abre en nueva pestaña
			window.open(url, '_blank');
		}
	},
};
</script>